import { throttle, set, unset } from 'lodash'
import postcss from 'postcss'

import CodeManager from 'Functions/code-manager'
// https://www.npmjs.com/package/postcss-clean
// import clean from 'postcss-clean'
import clean from './postcss/postcss-clean'
import removeDuplicateProperties from './postcss/postcss-remove-duplicate-properties'
/* ---------------------------------------------------- */
/* Update save button                                   */
/* ---------------------------------------------------- */
window.stlst_legacy.option_change = function() {
	return onOptionChange()
}

let tempAttrs = false // Temporary var to pass data through to the throttled function.
const callDebouncedOnOptionChange = throttle( debouncedOnOptionChange, 200 )

export default function onOptionChange( attrs = false ) {
	tempAttrs = attrs
	callDebouncedOnOptionChange()
}

function debouncedOnOptionChange() {
	const attrs = tempAttrs
	tempAttrs = false
	const editorCSS = CodeManager.getCode()
	// Convert per-property <style>s into CSS string.
	const newCssData = window.stlst_legacy.get_clean_css( true )

	if ( attrs ) {
		// If we have modified CSS code by design controler (slider, switch, etc.),
		// go ahead and change it in the editor CSS using PostCSS.
		changeCssValueWithPostCSS( editorCSS, attrs )
	}
}

export function changeCssValueWithPostCSS( editorCSS, attrs ) {
	postcss( [
		changeValueInCss( {
			cssSelector: attrs.selector,
			cssProperty: attrs.css,
			cssValue: attrs.current,
			responsiveSize: attrs.size,
		} )
	] ).process( editorCSS ).then( result => {
		// Update temporary CSS values cache
		set( window.Stylist.cachedCssValues, '["' + attrs.selector + '"]' + '["' + attrs.size + '"]' + '["' + attrs.css + '"]', attrs.current )

		if ( 'margin' === attrs.css || 'padding' === attrs.css ) {
			// Remove from CSS values cache.
			unset( window.Stylist.cachedCssValues, '["' + attrs.selector + '"]["' + attrs.size + '"]' + '["' + attrs.css + '-top"]' )
			unset( window.Stylist.cachedCssValues, '["' + attrs.selector + '"]["' + attrs.size + '"]' + '["' + attrs.css + '-right"]' )
			unset( window.Stylist.cachedCssValues, '["' + attrs.selector + '"]["' + attrs.size + '"]' + '["' + attrs.css + '-bottom"]' )
			unset( window.Stylist.cachedCssValues, '["' + attrs.selector + '"]["' + attrs.size + '"]' + '["' + attrs.css + '-left"]' )
		}

		if ( 'border-radius' === attrs.css ) {
			// Remove from CSS values cache.
			unset( window.Stylist.cachedCssValues, '["' + attrs.selector + '"]["' + attrs.size + '"]' + '["border-top-left-radius"]' )
			unset( window.Stylist.cachedCssValues, '["' + attrs.selector + '"]["' + attrs.size + '"]' + '["border-top-right-radius"]' )
			unset( window.Stylist.cachedCssValues, '["' + attrs.selector + '"]["' + attrs.size + '"]' + '["border-bottom-left-radius"]' )
			unset( window.Stylist.cachedCssValues, '["' + attrs.selector + '"]["' + attrs.size + '"]' + '["border-bottom-right-radius"]' )
		}
		saveModifiedCss( result.css )
	} )

	// @todo: you can make this code faster by replaceing process to parse
}

export function optimizeCodeWithPostCSS( editorCSS ) {
	return new Promise( ( resolve, reject ) => {
		// CSS editor code changed manually or no chance has been set yet.
		postcss( [
			clean( {
				level: {
					1: {
						all: true
					},
					2: {
						// all: false,
						mergeAdjacentRules: false, // Don't turn it on!
						// As it merges diferent selectors that has the same rules.
						mergeNonAdjacentRules: 'selector',
						restructureRules: true

						/*
						DEFAULT SETTINGS:
						mergeNonAdjacent: true,
						mergeIntoShorthands: true, // controls merging properties into shorthands; defaults to true
						mergeNonAdjacentRules: true, // controls non-adjacent rule merging; defaults to true
						mergeSemantically: false, // controls semantic merging; defaults to false

						overrideProperties: true, // controls property overriding based on understandability; defaults to true
						removeEmpty: true, // controls removing empty rules and nested blocks; defaults to `true`
						reduceNonAdjacentRules: true, // controls non-adjacent rule reducing; defaults to true
						removeDuplicateFontRules: true, // controls duplicate `@font-face` removing; defaults to true
						removeDuplicateMediaBlocks: true, // controls duplicate `@media` removing; defaults to true

						removeDuplicateRules: true, // controls duplicate rules removing; defaults to true
						removeUnusedAtRules: false, // controls unused at rule removing; defaults to false (available since 4.1.0)
						restructureRules: false, // controls rule restructuring; defaults to false
						*/
					}
				}, // https://github.com/jakubpawlowicz/clean-css#level-2-optimizations
				// these applied as well: https://github.com/jakubpawlowicz/clean-css#level-1-optimizations
				format: {
					semicolonAfterLastProperty: true,
					// 'beautify', // formats output in a really nice way
					breaks: { // controls where to insert breaks
						afterAtRule: true, // controls if a line break comes after an at-rule; e.g. `@charset`; defaults to `false`
						afterBlockBegins: true, // controls if a line break comes after a block begins; e.g. `@media`; defaults to `false`
						afterBlockEnds: true, // controls if a line break comes after a block ends, defaults to `false`
						afterComment: true, // controls if a line break comes after a comment; defaults to `false`
						afterProperty: true, // controls if a line break comes after a property; defaults to `false`
						afterRuleBegins: true, // controls if a line break comes after a rule begins; defaults to `false`
						afterRuleEnds: true, // controls if a line break comes after a rule ends; defaults to `false`
						beforeBlockEnds: true, // controls if a line break comes before a block ends; defaults to `false`
						betweenSelectors: true // controls if a line break comes between selectors; defaults to `false`
					},
					indentBy: 1,
					indentWith: 'tab',
					spaces: { // controls where to insert spaces
						aroundSelectorRelation: true, // controls if spaces come around selector relations; e.g. `div > a`; defaults to `false`
						beforeBlockBegins: true, // controls if a space comes before a block begins; e.g. `.block {`; defaults to `false`
						beforeValue: true // controls if a space comes before a value; e.g. `width: 1rem`; defaults to `false`
					},
				}
			} ),
			removeDuplicateProperties()
		] ).process( editorCSS ).then( result => {
			saveModifiedCss( result.css )
			resolve( result.css )
		} )
	} )

	// @todo: you can make this code faster by replaceing process to parse
}

function saveModifiedCss( modifiedCss ) {
	// Update css editor with optimized version of CSS.
	CodeManager.setCode( modifiedCss )
	// ↑ Triggers onCodeEditorChange()

	// Update breakpoints if we are in the responsive mode currently.
	if ( window.stlst_legacy.is_responsive_mod() ) {
		window.stlst_legacy.updateResponsiveBreakpoints();
	}
}

function changeValueInCss( { cssSelector, cssProperty, cssValue, responsiveSize } = attrs ) {
	// Wrap background image value into url()
	/* if ( 'background-image' === cssProperty ) {
		cssValue = 'url("' + cssValue + '")'
	}
	*/
	// const cssPropertyShort = getShothandCssPropertyFor( cssProperty )
	// Documentation: http://api.postcss.org/
	return ( root, result ) => {
		let ruleIndex = false
		let cssPropertyReplaced = false

		// FIND AND REPLACE PROPERTY:
		// https://regex101.com/r/vRUjj2/11
		const selectorRegex = new RegExp( "(?:^\\s*|,\\s*)" + window.stlst_legacy.prepare_regex_string( cssSelector ) + "(?:\\s*,|\\s*$)", "m" )
		// ↑ don't use "g" (global) key in the regex above!

		let cssPropertyRegex = cssProperty
		let shorthandProp = false
		// If shorthand properties → select all the directional properties as well
		if	( 'margin' === cssProperty || 'padding' === cssProperty ) {
			// https://regex101.com/r/tIjZaZ/2
			// cssPropertyRegex = new RegExp( "(?:^\\s*|;\\s*|{\\s*)" + window.stlst_legacy.prepare_regex_string( cssProperty ) + "(?::|-)", "m" )
			cssPropertyRegex = new RegExp( window.stlst_legacy.prepare_regex_string( cssProperty ) + "(?:[-a-z]*)", "m" )
			// ↑ don't use "g" (global) key in the regex above!
			shorthandProp = true
		} else if ( 'border-radius' === cssProperty ) {
			// https://regex101.com/r/CPmt1C/1
			cssPropertyRegex = new RegExp( "border-(top-left|top-right|bottom-right|bottom-left)-radius", "m" )
			// ↑ don't use "g" (global) key in the regex above!
			shorthandProp = true
		}

		// Find all the rules with the same selector.
		//				↓ Filter	 	↓ Callback
		root.walkRules( selectorRegex, ( rule, index ) => {
			// Only works with rules with exact the same selector.
			// Not composed/merged ones.
			if ( rule.selector.includes( ',' ) ) {
				return
			}

			let currentSize = 'desktop'
			// Check if we have any mediaQueries as grand-parent rule?
			if ( "atrule" === rule.parent.type &&
				"media" === rule.parent.name ) {
				currentSize = rule.parent.params // ex: (min-width:320px)
			}

			if ( responsiveSize == currentSize ) {
				// Save current rule index as appropriate
				// for adding new value later if we find no property to replace.
				ruleIndex = index

				// @todo: need to solve problem with shorthand properties margin-top/maring etc.
				// Find CSS declaration to replace with the property name we need.
				rule.walkDecls( cssPropertyRegex, ( decl, declIndx ) => {
					// Change found declaration for updated property.
					if ( responsiveSize == currentSize ) {
						// Delete directional properties like top/right/bottom/left
						// if the shorthand property defined.
						if ( shorthandProp && decl.prop !== cssProperty ) {
							decl.remove();
						}

						if ( 'string' === typeof cssValue && cssValue.indexOf( "!important" ) !== -1 ) {
							cssValue = cssValue.replace( '!important', '' )
							decl.important = true
						}

						if ( false !== cssValue ) {
							// Add new value.
							decl.value = cssValue
						} else {
							// Delete property declaration
							decl.remove();
						}

						cssPropertyReplaced = true
					}
					// Save value into the resulting cache object.
					// cachedAllValuesBySelector.responsiveSize.cssSelector.cssProperty = cssValue.
					// set( window.cachedAllValuesBySelector, currentSize + '["' + cssSelector + '"]' + decl.prop, decl.value  )
				} )
			}
		} )

		// IF DIDN'T FOUND TO REPLACE → ADD NEW PROPERTY:

		// Looks like we didn't find the property to replace. Let's add it then.
		// cssValue = false means we should delete existing value only
		if ( ! cssPropertyReplaced && false !== cssValue ) {
			// We found an appropriate rule (right selector and responsive size)
			// to add our new CSS declaration.
			if ( false !== ruleIndex ) { // Can be zero!
				root.nodes[ ruleIndex ].append(
					{ prop: cssProperty, value: cssValue }
				)
			} else {
				// If no good rule found – create one yourself.
				let newRule

				if ( 'desktop' === responsiveSize ) {
					// If css is for desktop
					// → add rule to the top of root
					// → add declaration to the created rule
					newRule = root.prepend( {
						selector: cssSelector
					} ).first.append( {
						prop: cssProperty,
						value: cssValue
					} )
				} else {
					// If css is for responsive
					// → add media query to the bottom of root
					// → add rule into the created media query
					// → add declaration to the created rule
					root.append( {
						name: 'media',
						params: responsiveSize // (min-width:768px)
					} ).last.append( {
						selector: cssSelector
					} ).last.append( {
						prop: cssProperty,
						value: cssValue
					} )
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/on-option-change.js